export default {
    it: {
        "title": "I tuoi dati",
        "name": "Nome",
        "surname": "Cognome",
        "email": "Email",
        "telephone": "Telefono fisso",
        "mobile": "Recapito telefonico",
        "job": "Occupazione",
        "piva": "Partita IVA",
        "codfisc": "Codice fiscale",
        "birthplace": "Luogo di nascita",
        "birthday": "Data di nascita",
        "telefon_mobile": "Recapito telefonico",
        "contact_times": "Fascia oraria di contatto",
        "ragione_sociale": "Ragione sociale",
        "importo_richiesto": "Importo richiesto (€)",
        "importo_ricevuta": "Importo richiesto (€)",
        "IBAN": "Iban",
        "intestatario": "Intestatario",
        "BIC_SWIFT": "Bic/Swift",
        "data_bonifico": "Data pagamento",
        "data_pagamento": "Data pagamento"


    },
    en: {
        "title": "Your infos",
        "name": "Name",
        "surname": "Surname",
        "email": "Email",
        "telephone": "Telefono fisso",
        "mobile": "Phone number",
        "job": "Job",
        "piva": "VAT number",
        "codfisc": "Tax ID code",
        "birthplace": "Birthplace",
        "birthday": "Birthday",
        "telefon_mobile": "Phone number",
        "contact_times": "Contact time slot",
        "ragione_sociale": "Company name",
        "importo_richiesto": "Requested amount",
        "IBAN": "Iban",
        "intestatario": "Account holder",
        "BIC_SWIFT": "Bic/Swift",
        "data_bonifico": "Payment date",
        "data_pagamento": "Payment date"

    }
}